import type {ContentBlock} from 'draft-js';

export interface MentionTriggerResult {
	start: number;
	query: string;
}

export function findMentionTrigger(block: ContentBlock, cursorOffset: number): MentionTriggerResult | null {
	const text = block.getText().slice(0, cursorOffset);

	const atIndex = text.lastIndexOf('@');
	if (atIndex < 0) return null;

	if (atIndex > 0 && text[atIndex - 1] !== ' ' && text[atIndex - 1] !== '\n') {
		return null;
	}

	const query = text.slice(atIndex + 1);

	if (/\s/.test(query)) return null;

	return {start: atIndex, query};
}
